module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._v("\n            Check SMS\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('p', [_c('strong', [_vm._v("Response:")]), _vm._v("  " + _vm._s(_vm.data))]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkSMS()
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "Mobile"
    }
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.mobile),
      expression: "form.mobile"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "mobile",
      "placeholder": "Enter mobile"
    },
    domProps: {
      "value": (_vm.form.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "mobile", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.smsTemplate),
      expression: "form.smsTemplate"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "smsTemplate",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.form.smsTemplate, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "smsTemplate", "1")
      }
    }
  }), _vm._v("\n                  Loan Disbursement \n                  "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "smsTemplate"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.smsTemplate),
      expression: "form.smsTemplate"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "smsTemplate",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.form.smsTemplate, "2")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "smsTemplate", "2")
      }
    }
  }), _vm._v("\n                  Member Registration \n                  "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "smsTemplate"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.smsTemplate),
      expression: "form.smsTemplate"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "smsTemplate",
      "value": "3"
    },
    domProps: {
      "checked": _vm._q(_vm.form.smsTemplate, "3")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "smsTemplate", "3")
      }
    }
  }), _vm._v("\n                  Document Verification\n                  "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "smsTemplate"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.smsTemplate),
      expression: "form.smsTemplate"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "smsTemplate",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.form.smsTemplate, "4")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "smsTemplate", "4")
      }
    }
  }), _vm._v("\n                  Due Emi SMS \n                  "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "smsTemplate"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.smsTemplate),
      expression: "form.smsTemplate"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "smsTemplate",
      "value": "5"
    },
    domProps: {
      "checked": _vm._q(_vm.form.smsTemplate, "5")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "smsTemplate", "5")
      }
    }
  }), _vm._v("\n                  Emi Collection \n                  "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "smsTemplate"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.smsTemplate),
      expression: "form.smsTemplate"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "smsTemplate",
      "value": "6"
    },
    domProps: {
      "checked": _vm._q(_vm.form.smsTemplate, "6")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "smsTemplate", "6")
      }
    }
  }), _vm._v("\n                  OTP SMS\n                  "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "smsTemplate"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.smsTemplate),
      expression: "form.smsTemplate"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "smsTemplate",
      "value": "7"
    },
    domProps: {
      "checked": _vm._q(_vm.form.smsTemplate, "7")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "smsTemplate", "7")
      }
    }
  }), _vm._v("\n                  Login Credentials\n                  "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "smsTemplate"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.smsTemplate),
      expression: "form.smsTemplate"
    }],
    staticClass: "minimal",
    attrs: {
      "type": "radio",
      "name": "smsTemplate",
      "value": "8"
    },
    domProps: {
      "checked": _vm._q(_vm.form.smsTemplate, "8")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.form, "smsTemplate", "8")
      }
    }
  }), _vm._v("\n                  Salary Disbursement \n                  "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "smsTemplate"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "value": "Submit",
      "name": "submit"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._v("\n            Check EMAIL\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('p', [_c('strong', [_vm._v("Response:")]), _vm._v("  " + _vm._s(_vm.data))]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkEmail()
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "Mobile"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "mobile",
      "placeholder": "Enter Email Id"
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "value": "Submit",
      "name": "submit"
    }
  })])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-54568d8c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/master/company/SmsSetting.vue
// module id = 844
// module chunks = 0